var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStoreFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24px/app_store_filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M14.5404 5.87819C15.1912 5.09685 15.5119 4.09256 15.4342 3.07861C14.4398 3.18305 13.5213 3.6583 12.8617 4.40967C12.5391 4.77673 12.2921 5.20376 12.1347 5.66634C11.9773 6.12893 11.9126 6.618 11.9444 7.1056C12.4417 7.11072 12.9338 7.00291 13.3835 6.79031C13.8331 6.5777 14.2287 6.26583 14.5404 5.87819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M16.8757 12.366C16.8843 11.6966 17.0621 11.0402 17.3926 10.458C17.723 9.87573 18.1954 9.38654 18.7657 9.03592C18.4034 8.51848 17.9254 8.09265 17.3698 7.79225C16.8141 7.49185 16.196 7.32515 15.5647 7.3054C14.2179 7.16403 12.9122 8.1113 12.2259 8.1113C11.5263 8.1113 10.4697 7.31943 9.33179 7.34285C8.59579 7.36662 7.8785 7.58065 7.24981 7.96406C6.62112 8.34748 6.10247 8.88721 5.74439 9.53067C4.19327 12.2162 5.35026 16.163 6.83611 18.3338C7.57951 19.3968 8.44833 20.5841 9.58516 20.542C10.6976 20.4959 11.1131 19.8326 12.4559 19.8326C13.7863 19.8326 14.1761 20.542 15.336 20.5152C16.5297 20.4959 17.2818 19.4476 17.9992 18.3745C18.5333 17.6171 18.9443 16.78 19.217 15.8942C18.5235 15.6009 17.9316 15.1099 17.5153 14.4825C17.0989 13.8551 16.8765 13.119 16.8757 12.366Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreFilled);
export default __webpack_public_path__ + "static/media/app_store_filled.249fcc88a4dade48db50d37f91ec0075.svg";
export { ForwardRef as ReactComponent };